import HSHeader from '@vendor/hs-header/src/js/hs-header' 
import HSMegaMenu from '@vendor/hs-mega-menu/src/js/hs-mega-menu' 
//import AOS from '@vendor/aos/dist/aos'

import HsGoTo from '@vendor/hs-go-to/src/js/hs-go-to'
import { initPluginIsotope} from "./theme/initPluginIsotope";
import 'odometer/themes/odometer-theme-default.css';

import "flickity"
//
// Header
// 
new HSHeader('#header').init()

//
// Mega Menu
// 

new HSMegaMenu('.js-mega-menu', {
	desktop: {
		position: 'left'
	}
})

initPluginIsotope()
//
// AOS
//

// AOS.init({
// 	duration: 650,
// 	mirror: true
// });


//
// JS GO TO
//

new HsGoTo('.js-go-to')